import Component from "../abstracts/Component";
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";

export default class SizeSelectorComponent extends Component {
  get COMPONENTNAME() {
    return "SizeSelectorComponent";
  }

  get SELECTORS() {
    return {
      trigger: "[data-sizes-trigger]",
      triggerButton: "[data-sizes-trigger] > button",
      select: "[data-sizes-select]",
      dropdown: "[data-sizes-dropdown]",
      size: "[data-size]",
      sizeError: "[data-sizes-error]",
      pdpMain: "[data-pdp-main]",
      toBag: "[data-pdp-bag]",
      notify: "[data-pdp-notify]",
      sizeSelected: "[data-size-selected]",
      sizesInfo: "[data-sizes-info]",
      sizeLabel: "[data-label]"
    };
  }

  constructor(compEl) {
    super(compEl);
    this.clickOutside = this.clickOutside.bind(this);
    this.trigger = this.$component.querySelector(this.SELECTORS.trigger);
    this.triggerButton = this.$component.querySelector(
      this.SELECTORS.triggerButton
    );
    this.sizeSelect = this.$component.querySelector(this.SELECTORS.select);
    this.sizeDropdown = this.$component.querySelector(this.SELECTORS.dropdown);
    this.sizes = this.$component.querySelectorAll(this.SELECTORS.size);
    this.sizeError = this.$component.querySelector(this.SELECTORS.sizeError);
    this.mainSelector = this.$component.dataset.main == "true";
    this.pdpMain = document.querySelector(this.SELECTORS.pdpMain);
    this.toBag = this.pdpMain.querySelector(this.SELECTORS.toBag);
    this.notify = this.pdpMain.querySelector(this.SELECTORS.notify);
    this.selected = this.$component.querySelector(this.SELECTORS.sizeSelected);
    this.box = this.$component;
    this.sizesInfo = this.$component.querySelector(this.SELECTORS.sizesInfo);
    this.dropdownCurrentIndex = 0;
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000
    });
  }

  toggleDropdown() {
    this.trigger.classList.toggle("open");
    const isOpen = this.trigger.classList.contains("open");
    this.triggerButton.setAttribute("aria-expanded", isOpen);
    this.trigger.scrollIntoView({ behavior: "smooth", block: "center" });
    document.addEventListener("click", this.clickOutside);
    this.sizeDropdown.addEventListener("click", e => e.stopPropagation());
    this.sizeDropdown.setAttribute("tabindex", isOpen ? "0" : "-1");
    this.sizes.forEach(size => {
      size.setAttribute("tabindex", isOpen ? "0" : "-1");
    });
  }

  closeDropdown() {
    this.trigger.classList.remove("open");
    document.removeEventListener("click", this.clickOutside);
    this.sizeDropdown.setAttribute("tabindex", "-1");
    this.triggerButton.setAttribute("aria-expanded", "false");
    this.triggerButton.focus();
    this.setDropdownCurrentIndex();
  }

  clickOutside(e) {
    if (e.target != this.trigger && e.target != this.sizesInfo) {
      this.closeDropdown();
    }
  }

  selectSize(size) {
    const buttonComboBox = size.parentElement.parentElement.querySelector(
      "button"
    );
    const label = buttonComboBox.querySelector(this.SELECTORS.sizeLabel);
    const select = size.parentElement.parentElement.querySelector("select");

    buttonComboBox && buttonComboBox.setAttribute("aria-invalid", "false");
    let prevSize = this.sizeDropdown.querySelector(".selected");
    if (prevSize) {
      prevSize.classList.remove("selected");
      prevSize.setAttribute("aria-selected", "false");
    }
    size.classList.add("selected");
    size.setAttribute("aria-selected", "true");
    const ariaLabel = size.getAttribute("aria-label");
    select.value = size.dataset.value;
    this.selected.innerHTML = size.innerHTML;
    this.selected.dataset.unavailable = size.dataset.unavailable;
    this.selected.setAttribute("aria-label", ariaLabel);
    label.innerHTML = ariaLabel;
    buttonComboBox.setAttribute("aria-activedescendant", size.id);
    buttonComboBox.setAttribute("aria-label", ariaLabel);
    this.closeDropdown();
  }

  cleanSelectSize() {
    this.sizes.forEach(size => {
      size.classList.remove("selected");
    });
    // reset value
    if (typeof this.sizeSelect !== "undefined" && this.sizeSelect != null) {
      this.sizeSelect.value = "";
    }
  }

  setDropdownCurrentIndex() {
    this.dropdownCurrentIndex =
      Array.from(this.sizes).indexOf(
        this.sizeDropdown.querySelector(".selected")
      ) || 0;
  }

  sizeDropdownEvents() {
    const ctx = this;
    this.setDropdownCurrentIndex();
    this.sizeDropdown.addEventListener("keydown", e => {
      // down arrow
      if (e.keyCode === 40) {
        e.preventDefault();
        if (ctx.dropdownCurrentIndex < ctx.sizes.length - 1) {
          ctx.dropdownCurrentIndex++;
          ctx.sizes[ctx.dropdownCurrentIndex].focus();
        }
      }
      if (e.keyCode === 38) {
        e.preventDefault();
        if (ctx.dropdownCurrentIndex > 0) {
          ctx.dropdownCurrentIndex--;
          ctx.sizes[ctx.dropdownCurrentIndex].focus();
        }
      }
      if (e.keyCode === 27) {
        e.preventDefault();
        ctx.closeDropdown();
      }
      // tab action
      if (e.keyCode === 9) {
        e.preventDefault();
        e.stopPropagation();
        const currentButton =
          ctx.sizes[
            ctx.dropdownCurrentIndex === -1 ? 0 : ctx.dropdownCurrentIndex
          ];
        currentButton.click();
        currentButton.focus();
      }
    });

    this.sizeDropdown.addEventListener("transitionend", () => {
      const isOpen = ctx.trigger.classList.contains("open");
      console.log("dropdown transitionend", isOpen);
      if (isOpen && ctx.sizes.length) {
        const selected = Array.from(this.sizes).indexOf(
          this.sizeDropdown.querySelector(".selected")
        );
        ctx.sizes[selected !== -1 ? selected : 0].focus();
      }
    });
  }

  bindEvents() {
    let ctx = this;
    //
    this.trigger.addEventListener("click", () => {
      this.toggleDropdown();
    });
    this.triggerButton.addEventListener("click", e => {
      e.stopPropagation();
      e.preventDefault();
      ctx.toggleDropdown();
    });
    if (this.sizesInfo) {
      this.sizesInfo.addEventListener("click", () => {
        this.toggleDropdown();
      });
    }
    if (this.sizes.length) {
      this.sizes.forEach(size => {
        size.addEventListener("click", () => {
          // put size
          this.selectSize(size);
          // if not available launch notify me event
          if (size.dataset.unavailable == "true") {
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, {
              size: size,
              box: this.box
            });
          } else {
            // if available i want to hide the notifyme form
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymeclose, {
              size: size,
              box: this.box
            });
          }
          // general event
          this.$emit(this.$customEvents.PRODUCT_EVENTS.sizechanged, {
            button: size
          });
          // reset error
          if (this.sizeError) {
            this.sizeError.innerHTML = "";
            this.sizeError.classList.remove("show");
          }
        });
        if (size.dataset.uniqueSize == "true") {
          this.selectSize(size);
        }
      });
    }

    // on notifymeended reset select
    this.$on(
      this.$customEvents.PRODUCT_EVENTS.notifymeended,
      ({ event, payload }) => {
        // reset value
        this.cleanSelectSize();
      }
    );

    // Size not selected event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, e => {
      let sizeErrorBoxes = document.querySelectorAll(
        "[data-sizes-error=prod-" + e.payload.dataset.code + "]"
      );
      let sizeSelects = document.querySelectorAll(
        "[data-sizes-trigger=prod-" + e.payload.dataset.code + "]"
      );
      // put error
      const labelError = e.payload.attributes["data-notification"].nodeValue;
      ctx.liveRegion.sayMessage(labelError);
      sizeErrorBoxes.forEach(sizeErrorBox => {
        if (sizeErrorBox && !sizeErrorBox.classList.contains("show")) {
          sizeErrorBox.classList.add("show");
          sizeErrorBox.innerHTML = labelError;
        }
      });
      sizeSelects.forEach(sizeSelect => {
        const select = sizeSelect.querySelector("[data-sizes-select]");
        const buttonComboBox = sizeSelect.querySelector("button");
        select.setAttribute("aria-invalid", "true");
        buttonComboBox.focus();
      });
    });
    this.sizeDropdownEvents();
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
  }
}
